import React from "react";

interface FormTextProps {
  label: string;
}
export const FormText: React.FC<FormTextProps> = ({ label }) => {
  return <span className="form-static-text">{label}</span>;
};
